import coinAngle2 from './coinAngle02.webp';
import coinAngle4 from './coinAngle04.webp';
import coinAngle7 from './coinAngle07.webp';
import coinAngle9 from './coinAngle09.webp';
import coinAngle11 from './coinAngle11.webp';
import coinAngle12 from './coinAngle12.webp';
import coinAngle17 from './coinAngle17.webp';
import coinAngle18 from './coinAngle18.webp';
import crystals from './crystals.webp';

export default {
  coinAngle2,
  coinAngle4,
  coinAngle7,
  coinAngle9,
  coinAngle11,
  coinAngle12,
  coinAngle17,
  coinAngle18,
  crystals,
};
